export default __webpack_public_path__ + "static/media/SAL5.47a541c9.jpg";